/**
 * Firebase設定（admin用）
 * ポート番号は .env.development の環境変数から取得
 */

const isEmulator = process.env.REACT_APP_USE_EMULATOR === "true";

const getPort = (envVar: string): number => {
  const value = process.env[envVar];
  if (!value) {
    throw new Error(`${envVar} が設定されていません（.env.development を確認してください）`);
  }
  return parseInt(value, 10);
};

// エミュレータ設定（遅延評価 — isEmulator=true のときだけ環境変数を参照）
const emulatorSettings = isEmulator ? buildSettings() : null;

function buildSettings() {
  const authPort = getPort("REACT_APP_EMULATOR_AUTH_PORT");
  const firestorePort = getPort("REACT_APP_EMULATOR_FIRESTORE_PORT");
  const functionsPort = getPort("REACT_APP_EMULATOR_FUNCTIONS_PORT");
  const storagePort = getPort("REACT_APP_EMULATOR_STORAGE_PORT");

  return {
    auth: {
      host: "localhost",
      port: authPort,
      url: `localhost:${authPort}`,
      httpUrl: `http://localhost:${authPort}`,
    },
    firestore: {
      host: "localhost",
      port: firestorePort,
      url: `localhost:${firestorePort}`,
    },
    functions: {
      host: "localhost",
      port: functionsPort,
      url: `localhost:${functionsPort}`,
    },
    storage: {
      host: "localhost",
      port: storagePort,
      url: `localhost:${storagePort}`,
    },
    apiUrl: `http://localhost:${functionsPort}/ripuren-8609e/asia-northeast1/api`,
  };
}

// 本番設定
const productionConfig = {
  apiUrl: "https://asia-northeast1-ripuren-8609e.cloudfunctions.net/api",
};

// 環境に応じた設定をエクスポート
export const firebaseSettings = {
  isEmulator,
  apiUrl: emulatorSettings ? emulatorSettings.apiUrl : productionConfig.apiUrl,
  emulator: emulatorSettings,
};

// エミュレータ設定へのアクセス（本番ではエラー）
export const getEmulatorConfig = () => {
  if (!emulatorSettings) {
    throw new Error(
      "getEmulatorConfig() called in production mode. Set REACT_APP_USE_EMULATOR=true"
    );
  }
  return emulatorSettings;
};

export default firebaseSettings;
